/**
 * 掛載途中 mount 容器被移出 DOM 時拋出，代表可重試狀態而非付款失敗。
 * 上層應重試掛載，不該關窗或呈現通用錯誤。
 */
export class CkoMountContainerDetachedError extends Error {
  override readonly name = 'CkoMountContainerDetachedError'

  constructor(readonly containerId: string) {
    super(`[CkoMountContainerDetachedError] mount container #${containerId} left the DOM during mount`)
  }
}

export const isCkoMountContainerDetachedError = (error: unknown): error is CkoMountContainerDetachedError =>
  error instanceof CkoMountContainerDetachedError
